{
  "labels": {
    "paste": "Lipire",
    "pasteAsPlaintext": "Inserare ca text simplu",
    "pasteCharts": "Lipire diagrame",
    "selectAll": "Selectare totală",
    "multiSelect": "Adaugă element la selecție",
    "moveCanvas": "Mutare pânză",
    "cut": "Decupare",
    "copy": "Copiere",
    "copyAsPng": "Copiere în memoria temporară ca PNG",
    "copyAsSvg": "Copiere în memoria temporară ca SVG",
    "copyText": "Copiere în memoria temporară ca text",
    "copySource": "Copiere sursă în memoria temporară",
    "convertToCode": "Convertire în cod",
    "bringForward": "Aducere în plan apropiat",
    "sendToBack": "Trimitere în ultimul plan",
    "bringToFront": "Aducere în prim plan",
    "sendBackward": "Trimitere în plan secundar",
    "delete": "Ștergere",
    "copyStyles": "Copiere stiluri",
    "pasteStyles": "Lipire stiluri",
    "stroke": "Contur",
    "changeStroke": "Modificare culoare contur",
    "background": "Fundal",
    "changeBackground": "Modificare culoare de contur",
    "fill": "Umplere",
    "strokeWidth": "Lățimea conturului",
    "strokeStyle": "Stilul conturului",
    "strokeStyle_solid": "Neîntrerupt",
    "strokeStyle_dashed": "Liniuțe",
    "strokeStyle_dotted": "Punctat",
    "sloppiness": "Aspectul trasării",
    "opacity": "Opacitate",
    "textAlign": "Alinierea textului",
    "edges": "Margini",
    "sharp": "Ascuțite",
    "round": "Rotunde",
    "arrowheads": "Vârfuri de săgeată",
    "arrowhead_none": "Niciunul",
    "arrowhead_arrow": "Săgeată",
    "arrowhead_bar": "Bară",
    "arrowhead_circle": "Cerc",
    "arrowhead_circle_outline": "Cerc (contur)",
    "arrowhead_triangle": "Triunghi",
    "arrowhead_triangle_outline": "Triunghi (contur)",
    "arrowhead_diamond": "Romb",
    "arrowhead_diamond_outline": "Romb (contur)",
    "arrowhead_crowfoot_many": "Model entitate-asociere (multe)",
    "arrowhead_crowfoot_one": "Model entitate-asociere (unul)",
    "arrowhead_crowfoot_one_or_many": "Model entitate-asociere (unul sau multe)",
    "more_options": "Mai multe opțiuni",
    "arrowtypes": "Tip de săgeată",
    "arrowtype_sharp": "Săgeată ascuțită",
    "arrowtype_round": "Săgeată curbată",
    "arrowtype_elbowed": "Săgeată arcuită",
    "fontSize": "Dimensiune font",
    "fontFamily": "Familia de fonturi",
    "addWatermark": "Adaugă „Realizat cu Excalidraw”",
    "handDrawn": "Scris de mână",
    "normal": "Normal",
    "code": "Cod",
    "small": "Mică",
    "medium": "Medie",
    "large": "Mare",
    "veryLarge": "Foarte mare",
    "solid": "Plină",
    "hachure": "Hașură",
    "zigzag": "Zigzag",
    "crossHatch": "Hașură transversală",
    "thin": "Subțire",
    "bold": "Îngroșată",
    "left": "Stânga",
    "center": "Centru",
    "right": "Dreapta",
    "extraBold": "Extra îngroșată",
    "architect": "Arhitect",
    "artist": "Artist",
    "cartoonist": "Caricaturist",
    "fileTitle": "Nume de fișier",
    "colorPicker": "Selector de culoare",
    "canvasColors": "Folosite pe pânză",
    "canvasBackground": "Fundalul pânzei",
    "drawingCanvas": "Pânză pentru desenat",
    "clearCanvas": "Ștergere pânză",
    "layers": "Straturi",
    "actions": "Acțiuni",
    "language": "Limbă",
    "liveCollaboration": "Colaborare în direct...",
    "duplicateSelection": "Duplicare",
    "untitled": "Nedenumit",
    "name": "Nume",
    "yourName": "Numele tău",
    "madeWithExcalidraw": "Realizat cu Excalidraw",
    "group": "Grupare selecție",
    "ungroup": "Degrupare selecție",
    "collaborators": "Colaboratori",
    "toggleGrid": "Comutare grilă",
    "addToLibrary": "Adăugare la bibliotecă",
    "removeFromLibrary": "Eliminare din bibliotecă",
    "libraryLoadingMessage": "Se încarcă biblioteca…",
    "libraries": "Răsfoiește bibliotecile",
    "loadingScene": "Se încarcă scena…",
    "loadScene": "Încărcare scenă din fișier",
    "align": "Aliniere",
    "alignTop": "Aliniere sus",
    "alignBottom": "Aliniere jos",
    "alignLeft": "Aliniere la stânga",
    "alignRight": "Aliniere la dreapta",
    "centerVertically": "Centrare verticală",
    "centerHorizontally": "Centrare orizontală",
    "distributeHorizontally": "Distribuie orizontal",
    "distributeVertically": "Distribuie vertical",
    "flipHorizontal": "Răsturnare orizontală",
    "flipVertical": "Răsturnare verticală",
    "viewMode": "Mod de vizualizare",
    "share": "Distribuie",
    "showStroke": "Afișare selector culoare contur",
    "showBackground": "Afișare selector culoare fundal",
    "showFonts": "Afișare selector font",
    "toggleTheme": "Comutare temă luminoasă/întunecată",
    "theme": "Temă",
    "personalLib": "Biblioteca personală",
    "excalidrawLib": "Biblioteca Excalidraw",
    "decreaseFontSize": "Micșorează dimensiunea fontului",
    "increaseFontSize": "Mărește dimensiunea fontului",
    "unbindText": "Deconectare text",
    "bindText": "Legare text de container",
    "createContainerFromText": "Încadrare text într-un container",
    "link": {
      "edit": "Editare URL",
      "editEmbed": "Editare link încorporabil",
      "create": "Adăugare link",
      "label": "URL",
      "labelEmbed": "URL și încorporare",
      "empty": "Nu este setat niciun URL",
      "hint": "Tastează-ți sau lipsește-ți linkul aici",
      "goToElement": "Accesează elementul țintă"
    },
    "lineEditor": {
      "edit": "Editare linie",
      "editArrow": "Editare săgeată"
    },
    "polygon": {
      "breakPolygon": "Întrerupere poligon",
      "convertToPolygon": "Convertire în poligon"
    },
    "elementLock": {
      "lock": "Blocare",
      "unlock": "Deblocare",
      "lockAll": "Blocare toate",
      "unlockAll": "Deblocare toate"
    },
    "statusPublished": "Publicat",
    "sidebarLock": "Păstrează deschisă bara laterală",
    "selectAllElementsInFrame": "Selectează toate elementele din cadru",
    "removeAllElementsFromFrame": "Elimină toate elementele din cadru",
    "eyeDropper": "Alegere culoare din pânză",
    "textToDiagram": "Text la diagramă",
    "prompt": "Mesaj sistem",
    "followUs": "Urmărește-ne",
    "discordChat": "Conversații pe Discord",
    "zoomToFitViewport": "Transfocare pentru a se potrivi în poarta de vizualizare",
    "zoomToFitSelection": "Transfocare pentru a cuprinde selecția",
    "zoomToFit": "Transfocare pentru a cuprinde toate elementele",
    "installPWA": "Instalează Excalidraw la nivel local (PWA)",
    "autoResize": "Activare autoredimensionare text",
    "imageCropping": "Decupare imagine",
    "unCroppedDimension": "Dimensiune nedecupată",
    "copyElementLink": "Copiere link către obiect",
    "linkToElement": "Link către obiect",
    "wrapSelectionInFrame": "Încapsulare selecție în cadru",
    "tab": "Filă",
    "shapeSwitch": "Comutare formă"
  },
  "elementLink": {
    "title": "Link către obiect",
    "desc": "Dă clic pe o formă pe pânză sau lipește un link.",
    "notFound": "Obiectul linkuit nu a fost găsit pe pânză."
  },
  "library": {
    "noItems": "Niciun element adăugat încă...",
    "hint_emptyLibrary": "Selectează un element de pe pânză pentru a-l adăuga aici sau instalează o bibliotecă din depozitul public, de mai jos.",
    "hint_emptyPrivateLibrary": "Selectează un element de pe pânză pentru a-l adăuga aici.",
    "search": {
      "inputPlaceholder": "Căutare în bibliotecă",
      "heading": "Potriviri din bibliotecă",
      "noResults": "Niciun element potrivit găsit...",
      "clearSearch": "Ștergere căutare"
    }
  },
  "search": {
    "title": "Găsire pe pânză",
    "noMatch": "Nicio potrivire găsită...",
    "singleResult": "rezultat",
    "multipleResults": "rezultate",
    "placeholder": "Găsire text pe pânză...",
    "frames": "Cadre",
    "texts": "Texte"
  },
  "buttons": {
    "clearReset": "Resetare pânză",
    "exportJSON": "Exportare la fișiere",
    "exportImage": "Exportare imagine...",
    "export": "Salvare în...",
    "copyToClipboard": "Copiere în memoria temporară",
    "copyLink": "Copiere link",
    "save": "Salvare în fișierul curent",
    "saveAs": "Salvare ca",
    "load": "Deschidere",
    "getShareableLink": "Obține URL partajabil",
    "close": "Închidere",
    "selectLanguage": "Selectare limbă",
    "scrollBackToContent": "Derulare înapoi la conținut",
    "zoomIn": "Apropiere",
    "zoomOut": "Depărtare",
    "resetZoom": "Resetare transfocare",
    "menu": "Meniu",
    "done": "Efectuat",
    "edit": "Editare",
    "undo": "Anulare",
    "redo": "Refacere",
    "resetLibrary": "Resetare bibliotecă",
    "createNewRoom": "Creare cameră nouă",
    "fullScreen": "Ecran complet",
    "darkMode": "Mod întunecat",
    "lightMode": "Mod luminos",
    "systemMode": "Mod de sistem",
    "zenMode": "Mod zen",
    "objectsSnapMode": "Ancorare la obiecte",
    "exitZenMode": "Ieșire din modul zen",
    "cancel": "Anulare",
    "saveLibNames": "Salvare nume și ieșire",
    "clear": "Ștergere",
    "remove": "Eliminare",
    "embed": "Comutare încorporare",
    "publishLibrary": "Redenumire sau publicare",
    "submit": "Trimitere",
    "confirm": "Confirmare",
    "embeddableInteractionButton": "Clic pentru interacționare"
  },
  "alerts": {
    "clearReset": "Această opțiune va șterge întreaga pânză. Confirmi?",
    "couldNotCreateShareableLink": "Nu s-a putut crea un URL partajabil.",
    "couldNotCreateShareableLinkTooBig": "Nu s-a putut crea un URL partajabil: scena este prea mare",
    "couldNotLoadInvalidFile": "Fișierul invalid nu a putut fi încărcat",
    "importBackendFailed": "Importarea de la nivel de server a eșuat.",
    "cannotExportEmptyCanvas": "Nu se poate exporta pânza goală.",
    "couldNotCopyToClipboard": "Nu s-a putut copia în memoria temporară.",
    "decryptFailed": "Datele nu au putut fi decriptate.",
    "uploadedSecurly": "Încărcarea a fost securizată prin criptare integrală, însemnând că serverul Excalidraw și terții nu pot citi conținutul.",
    "loadSceneOverridePrompt": "Încărcarea desenului extern va înlocui conținutul existent. Dorești să continui?",
    "collabStopOverridePrompt": "Oprirea sesiunii va suprascrie desenul anterior stocat local. Confirmi alegerea?\n\n(Dacă vrei să păstrezi desenul local, pur și simplu închide fila navigatorului în schimb.)",
    "errorAddingToLibrary": "Elementul nu a putut fi adăugat în bibliotecă",
    "errorRemovingFromLibrary": "Elementul nu a putut fi eliminat din bibliotecă",
    "confirmAddLibrary": "Această acțiune va adăuga {{numShapes}} formă(e) la biblioteca ta. Confirmi?",
    "imageDoesNotContainScene": "Această imagine nu pare să conțină date de scenă. Ai activat încorporarea scenei în timpul exportului?",
    "cannotRestoreFromImage": "Scena nu a putut fi restaurată din acest fișier de imagine",
    "invalidSceneUrl": "Scena nu a putut fi importată din URL-ul furnizat. Este fie incorect formată, fie nu conține date JSON Excalidraw valide.",
    "resetLibrary": "Această opțiune va elimina conținutul din bibliotecă. Confirmi?",
    "removeItemsFromsLibrary": "Ștergi {{count}} element(e) din bibliotecă?",
    "invalidEncryptionKey": "Cheia de criptare trebuie să aibă 22 de caractere. Colaborarea în direct este dezactivată.",
    "collabOfflineWarning": "Nu este disponibilă nicio conexiune la internet.\nModificările nu vor fi salvate!",
    "localStorageQuotaExceeded": "Cota pentru spațiul de stocare al navigatorului a fost depășită. Modificările nu vor fi salvate."
  },
  "errors": {
    "unsupportedFileType": "Tip de fișier neacceptat.",
    "imageInsertError": "Imaginea nu a putut fi introdusă. Reîncearcă mai târziu...",
    "fileTooBig": "Fișierul este prea mare. Dimensiunea maximă permisă este de {{maxSize}}.",
    "svgImageInsertError": "Imaginea SVG nu a putut fi introdus. Marcajul SVG pare invalid.",
    "failedToFetchImage": "Preluarea imaginii a eșuat.",
    "cannotResolveCollabServer": "Nu a putut fi realizată conexiunea la serverul de colaborare. Reîncarcă pagina și încearcă din nou.",
    "importLibraryError": "Biblioteca nu a putut fi încărcată",
    "saveLibraryError": "Nu s-a putut salva biblioteca în spațiul de stocare. Salvează-ți biblioteca într-un fișier local pentru a te asigura că nu pierzi modificările.",
    "collabSaveFailed": "Nu s-a putut salva în baza de date la nivel de server. Dacă problemele persistă, ar trebui să salvezi fișierul la nivel local pentru a te asigura că nu îți pierzi munca.",
    "collabSaveFailed_sizeExceeded": "Nu s-a putut salva în baza de date la nivel de server, întrucât se pare că pânza este prea mare. Ar trebui să salvezi fișierul la nivel local pentru a te asigura că nu îți pierzi munca.",
    "imageToolNotSupported": "Imaginile sunt dezactivate.",
    "brave_measure_text_error": {
      "line1": "Se pare că folosești navigatorul Brave cu opțiunea <bold>strictă pentru blocarea amprentării</bold>.",
      "line2": "Acest lucru poate duce la întreruperea <bold>elementelor text</bold> din desene.",
      "line3": "Îți recomandăm ferm să dezactivezi această setare. Poți urma <link>acești pași</link> pentru a face acest lucru.",
      "line4": "Dacă dezactivarea acestei setări nu duce la remedierea afișării elementelor text, deschide un tichet de <issueLink>problemă</issueLink> pe pagina noastră de GitHub sau scrie-ne pe <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Elementele încorporabile nu pot fi adăugate la bibliotecă.",
      "iframe": "Elementele iFrame nu pot fi adăugate la bibliotecă.",
      "image": "În curând vor putea fi adăugate imagini în bibliotecă!"
    },
    "asyncPasteFailedOnRead": "Lipirea nu a putut fi efectuată (nu s-a putut citit din memoria temporară a sistemului).",
    "asyncPasteFailedOnParse": "Lipirea nu a putut fi efectuată.",
    "copyToSystemClipboardFailed": "Nu s-a putut copia în memoria temporară."
  },
  "toolBar": {
    "selection": "Selecție",
    "lasso": "Selecție lasou",
    "image": "Introducere imagine",
    "rectangle": "Dreptunghi",
    "diamond": "Romb",
    "ellipse": "Elipsă",
    "arrow": "Săgeată",
    "line": "Linie",
    "freedraw": "Desenare",
    "text": "Text",
    "library": "Bibliotecă",
    "lock": "Menține activ instrumentul selectat după desenare",
    "penMode": "Mod stilou – împiedică atingerea",
    "link": "Adăugare/actualizare link pentru o formă selectată",
    "eraser": "Radieră",
    "frame": "Instrument cadru",
    "magicframe": "Structură-de-fire la cod",
    "embeddable": "Încorporare web",
    "laser": "Indicator laser",
    "hand": "Mână (instrument de panoramare)",
    "extraTools": "Mai multe instrumente",
    "mermaidToExcalidraw": "Mermaid la Excalidraw",
    "convertElementType": "Comutare tip formă"
  },
  "element": {
    "rectangle": "Dreptunghi",
    "diamond": "Romb",
    "ellipse": "Elipsă",
    "arrow": "Săgeată",
    "line": "Linie",
    "freedraw": "Desenare liberă",
    "text": "Text",
    "image": "Imagine",
    "group": "Grup",
    "frame": "Cadru",
    "magicframe": "Structură-de-fire la cod",
    "embeddable": "Încorporare web",
    "selection": "Selecție",
    "iframe": "iFrame"
  },
  "headings": {
    "canvasActions": "Acțiuni pentru pânză",
    "selectedShapeActions": "Acțiuni pentru forma selectată",
    "shapes": "Forme"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} pentru a închide căutarea",
    "canvasPanning": "Pentru a muta pânză, ține {{shortcut_1}} sau {{shortcut_2}} în timp ce glisezi sau folosește instrumentul în formă de mână",
    "linearElement": "Dă clic pentru a crea mai multe puncte, glisează pentru a forma o singură linie",
    "arrowTool": "Dă clic pentru a crea mai multe puncte, glisează pentru a forma o singură linie. Apasă {{shortcut}} din nou pentru a modifica tipul săgeții.",
    "arrowBindModifiers": "Ține apăsat {{shortcut_1}} pentru a dezactivarea legarea sau {{shortcut_2}} pentru a efectua legarea la un punct fix",
    "freeDraw": "Dă clic pe pânză și glisează cursorul, apoi eliberează-l când ai terminat",
    "text": "Sfat: poți adăuga text și dând dublu clic oriunde cu instrumentul de selecție",
    "embeddable": "Dă clic și trage pentru a crea un cod de încorporare de pagină web",
    "text_selected": "Dă dublu clic sau apasă {{shortcut}} pentru a edita textul",
    "text_editing": "Apasă {{shortcut_1}} sau {{shortcut_2}} pentru a finaliza editarea",
    "linearElementMulti": "Dă clic pe ultimul punct sau apasă {{shortcut_1}} sau {{shortcut_2}} pentru a finaliza",
    "lockAngle": "Poți constrânge unghiul prin ținerea apăsată a {{shortcut}}",
    "resize": "Poți constrânge proporțiile, ținând apăsat {{shortcut_1}} în timp ce redimensionezi,\nține apăsat {{shortcut_2}} pentru a redimensiona de la centru",
    "resizeImage": "Poți constrânge proporțiile, ținând apăsat {{shortcut_1}},\nține apăsat {{shortcut_2}} pentru a redimensiona de la centru",
    "rotate": "Poți constrânge unghiurile, ținând apăsat {{shortcut}} în timp ce rotești",
    "lineEditor_info": "Ține apăsat {{shortcut_1}} și dă dublu clic sau apasă {{shortcut_2}} pentru a edita punctele",
    "lineEditor_line_info": "Dă dublu clic sau apasă {{shortcut}} pentru a edita punctele",
    "lineEditor_pointSelected": "Apasă {{shortcut_1}} pentru a elimina punctele,\n{{shortcut_2}} pentru a duplica sau glisează pentru a muta",
    "lineEditor_nothingSelected": "Selectează un punct pentru a-l edita (ține apăsat {{shortcut_1}} pentru a selecta mai multe),\nsau ține apăsat {{shortcut_2}} și dă clic pentru a adăuga puncte noi",
    "publishLibrary": "Publică propria bibliotecă",
    "bindTextToElement": "{{shortcut}} pentru a adăuga text",
    "createFlowchart": "{{shortcut}} pentru a crea o organigramă",
    "deepBoxSelect": "Ține apăsat {{shortcut}} pentru a efectua selectarea de adâncime și pentru a preveni glisarea",
    "eraserRevert": "Ține apăsat {{shortcut}} pentru a anula elementele marcate pentru ștergere",
    "firefox_clipboard_write": "Această caracteristică poate fi probabil activată prin setarea preferinței „dom.events.asyncClipboard.clipboardItem” ca „true”. Pentru a schimba preferințele navigatorului în Firefox, accesează pagina „about:config”.",
    "disableSnapping": "Ține apăsat {{shortcut}} pentru a dezactiva ancorarea",
    "enterCropEditor": "Dă dublu clic pe imagine sau apasă {{shortcut}} pentru a decupa imaginea",
    "leaveCropEditor": "Dă clic în afara imaginii sau apasă {{shortcut_1}} sau {{shortcut_2}} pentru a finaliza decuparea"
  },
  "canvasError": {
    "cannotShowPreview": "Nu se poate afișa previzualizarea",
    "canvasTooBig": "Pânza poate fi prea mare.",
    "canvasTooBigTip": "Sfat: încearcă să apropii puțin mai mult elementele cele mai îndepărtate."
  },
  "errorSplash": {
    "headingMain": "A apărut o eroare. Încearcă <button>să reîncarci pagina</button>.",
    "clearCanvasMessage": "Dacă reîncărcarea nu funcționează, încearcă <button>să ștergi pânza</button>.",
    "clearCanvasCaveat": " Acest lucru va duce la pierderea progresului ",
    "trackedToSentry": "Eroarea cu identificatorul {{eventId}} a fost urmărită în sistemul nostru.",
    "openIssueMessage": "Am luat măsuri de precauție pentru a nu include informații despre scenă în eroare. Dacă scena nu este privată, oferă-ne mai multe informații în <button>monitorul nostru pentru erori</button>. Include informațiile de mai jos copiindu-le și lipindu-le în tichetul cu problemă de pe GitHub.",
    "sceneContent": "Conținutul scenei:"
  },
  "shareDialog": {
    "or": "Sau"
  },
  "roomDialog": {
    "desc_intro": "Invită persoane să colaboreze la desenul tău.",
    "desc_privacy": "Nu-ți face griji, sesiunea este criptată integral și complet privată. Nici măcar serverul nostru nu poate vedea ce desenezi.",
    "button_startSession": "Pornire sesiune",
    "button_stopSession": "Oprire sesiune",
    "desc_inProgressIntro": "Sesiunea de colaborare în direct este în curs de desfășurare.",
    "desc_shareLink": "Distribuie acest URL persoanelor cu care dorești să colaborezi:",
    "desc_exitSession": "Oprirea sesiunii te va deconecta de la sală, însă vei putea lucra în continuare, pe plan local, cu scena. Reține că această opțiune nu va afecta alte persoane, iar acestea vor putea să colaboreze în continuare pe versiunea lor.",
    "shareTitle": "Alătură-te unei sesiuni de colaborare în direct pe Excalidraw"
  },
  "errorDialog": {
    "title": "Eroare"
  },
  "exportDialog": {
    "disk_title": "Salvare pe disc",
    "disk_details": "Exportă datele scenei pe un fișier din care poți importa mai târziu.",
    "disk_button": "Salvare în fișier",
    "link_title": "URL partajabil",
    "link_details": "Exportă ca URL doar în citire.",
    "link_button": "Exportare în URL",
    "excalidrawplus_description": "Salvează scena în spațiul de lucru Excalidraw+.",
    "excalidrawplus_button": "Exportare",
    "excalidrawplus_exportError": "Excalidraw+ nu a putut fi exportat în acest moment..."
  },
  "helpDialog": {
    "blog": "Citește blogul nostru",
    "click": "clic",
    "deepSelect": "Selectare de adâncime",
    "deepBoxSelect": "Selectare de adâncime în casetă și prevenire glisare",
    "createFlowchart": "Crează o organigramă dintr-un element generic",
    "navigateFlowchart": "Navighează o organigramă",
    "curvedArrow": "Săgeată curbată",
    "curvedLine": "Linie curbată",
    "documentation": "Documentație",
    "doubleClick": "dublu clic",
    "drag": "glisare",
    "editor": "Editor",
    "editLineArrowPoints": "Editare puncte de săgeată/rând",
    "editText": "Editare text/adăugare etichetă",
    "github": "Ai întâmpinat o problemă? Trimite un raport",
    "howto": "Urmărește ghidurile noastre",
    "or": "sau",
    "preventBinding": "Împiedică legarea săgeții",
    "tools": "Instrumente",
    "shortcuts": "Comenzi rapide de la tastatură",
    "textFinish": "Finalizează editarea (editor de text)",
    "textNewLine": "Adaugă o linie nouă (editor de text)",
    "title": "Ajutor",
    "view": "Vizualizare",
    "zoomToFit": "Transfocare pentru a cuprinde toate elementele",
    "zoomToSelection": "Transfocare la selecție",
    "toggleElementLock": "Blocare/deblocare selecție",
    "movePageUpDown": "Deplasare pagină sus/jos",
    "movePageLeftRight": "Deplasare pagină stânga/dreapta",
    "cropStart": "Decupare imagine",
    "cropFinish": "Finalizare decupare imagine"
  },
  "clearCanvasDialog": {
    "title": "Ștergere pânză"
  },
  "publishDialog": {
    "title": "Publicare bibliotecă",
    "itemName": "Denumirea elementului",
    "authorName": "Numele autorului",
    "githubUsername": "Numele de utilizator GitHub",
    "twitterUsername": "Numele de utilizator Twitter",
    "libraryName": "Denumirea bibliotecii",
    "libraryDesc": "Descrierea bibliotecii",
    "website": "Pagină de internet",
    "placeholder": {
      "authorName": "Numele sau numele tău de utilizator",
      "libraryName": "Numele bibliotecii tale",
      "libraryDesc": "Descrierea bibliotecii tale pentru a ajuta oamenii să înțeleagă utilizarea acesteia",
      "githubHandle": "Numele de utilizator GitHub (opțional), pentru a putea edita biblioteca odată ce este trimisă spre revizuire",
      "twitterHandle": "Numele de utilizator Twitter (opțional), pentru a indica sursa la promovarea pe Twitter",
      "website": "Trimitere către pagina ta personală de internet sau altundeva (opțional)"
    },
    "errors": {
      "required": "Obligatoriu",
      "website": "Introdu un URL valid"
    },
    "noteDescription": "Trimite-ți biblioteca pentru a fi inclusă în <link>depozitul de biblioteci publice</link> în vederea utilizării de către alte persoane în desenele lor.",
    "noteGuidelines": "Biblioteca trebuie aprobată manual mai întâi. Citește <link>orientările</link> înainte de trimitere. Vei avea nevoie de un cont GitHub pentru a comunica și efectua modificări, dacă este cazul, însă nu este strict necesar.",
    "noteLicense": "Prin trimiterea bibliotecii, ești de acord că aceasta va fi publicată sub <link>Licența MIT, </link>care, pe scurt, înseamnă că oricine o poate folosi fără restricții.",
    "noteItems": "Fiecare element din bibliotecă trebuie să aibă propriul nume astfel încât să fie filtrabil. Următoarele elemente din bibliotecă vor fi incluse:",
    "atleastOneLibItem": "Selectează cel puțin un element din bibliotecă pentru a începe",
    "republishWarning": "Observație: unele dintre elementele selectate sunt marcate ca fiind deja publicate/trimise. Ar trebui să retrimiți elemente numai atunci când actualizezi o trimitere sau o bibliotecă existentă."
  },
  "publishSuccessDialog": {
    "title": "Bibliotecă trimisă",
    "content": "Îți mulțumim, {{authorName}}. Biblioteca a fost trimisă spre revizuire. Poți urmări starea <link>aici</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Resetare bibliotecă",
    "removeItemsFromLib": "Elimină elementele selectate din bibliotecă"
  },
  "imageExportDialog": {
    "header": "Exportare imagine",
    "label": {
      "withBackground": "Fundal",
      "onlySelected": "Numai selecția",
      "darkMode": "Mod întunecat",
      "embedScene": "Încorporare scenă",
      "scale": "Scală",
      "padding": "Spațiere"
    },
    "tooltip": {
      "embedScene": "Datele scenei vor fi salvate în fișierul PNG/SVG exportat, astfel că scena va putea fi restaurată din acesta.\nVa crește dimensiunea fișierului exportat."
    },
    "title": {
      "exportToPng": "Exportare ca PNG",
      "exportToSvg": "Exportare ca SVG",
      "copyPngToClipboard": "Copiere PNG în memoria temporară"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copiere în memoria temporară"
    }
  },
  "encrypted": {
    "tooltip": "Desenele tale sunt criptate integral, astfel că serverele Excalidraw nu le vor vedea niciodată.",
    "link": "Articol de blog pe criptarea integrală din Excalidraw"
  },
  "stats": {
    "angle": "Unghi",
    "shapes": "Forme",
    "height": "Înălțime",
    "scene": "Scenă",
    "selected": "Selectate",
    "storage": "Stocare",
    "fullTitle": "Proprietăți pentru pânză și forme",
    "title": "Proprietăți",
    "generalStats": "General",
    "elementProperties": "Proprietăți pentru forme",
    "total": "Total",
    "version": "Versiune",
    "versionCopy": "Clic pentru copiere",
    "versionNotAvailable": "Versiune indisponibilă",
    "width": "Lățime"
  },
  "toast": {
    "addedToLibrary": "Adăugat în bibliotecă",
    "copyStyles": "Stiluri copiate.",
    "copyToClipboard": "Copiat în memoria temporară.",
    "copyToClipboardAsPng": "S-a copiat {{exportSelection}} în memoria temporară sub formă de PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "S-a copiat {{exportSelection}} în memoria temporară sub formă de SVG\n({{exportColorScheme}})",
    "fileSaved": "Fișier salvat.",
    "fileSavedToFilename": "Salvat în {filename}",
    "canvas": "pânza",
    "selection": "selecția",
    "pasteAsSingleElement": "Folosește {{shortcut}} pentru a insera ca un singur element\nsau insera într-un editor de text existent",
    "unableToEmbed": "Încorporarea acestui URL nu este permisă momentan. Deschideți un tichet cu probleme pe GitHub pentru a solicita adăugarea acestui URL în lista albă",
    "unrecognizedLinkFormat": "URL-ul pe care l-ai încorporat nu coincide cu formatul așteptat. Încearcă să lipești șirul „de încorporat” furnizat de pagina sursă",
    "elementLinkCopied": "Link copiat în memoria temporară"
  },
  "colors": {
    "transparent": "Transparent",
    "black": "Negru",
    "white": "Alb",
    "red": "Roșu",
    "pink": "Roz",
    "grape": "Struguriu",
    "violet": "Violet",
    "gray": "Gri",
    "blue": "Albastru",
    "cyan": "Cyan",
    "teal": "Cyan-verde",
    "green": "Verde",
    "yellow": "Galben",
    "orange": "Portocaliu",
    "bronze": "Bronz"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Desenele tale sunt salvate în spațiul de stocare al navigatorului tău.",
      "center_heading_line2": "Spațiul de stocare al navigatorului poate fi șters în mod neașteptat.",
      "center_heading_line3": "Salvează-ți periodic munca într-un fișier pentru a evita pierderea acesteia.",
      "center_heading_plus": "Ai vrut să mergi în schimb la Excalidraw+?",
      "menuHint": "Exportare, preferințe, limbi, ..."
    },
    "defaults": {
      "menuHint": "Exportare, preferințe și mai multe...",
      "center_heading": "Diagrame. Făcute. Simple.",
      "toolbarHint": "Alege un instrument și începe să desenezi!",
      "helpHint": "Comenzi rapide și ajutor"
    }
  },
  "colorPicker": {
    "color": "Culoare",
    "mostUsedCustomColors": "Cele mai utilizate culori personalizate",
    "colors": "Culori",
    "shades": "Nuanțe",
    "hexCode": "Cod hexa",
    "noShades": "Nu este disponibilă nicio nuanță pentru această culoare"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportare ca imagine",
        "button": "Exportare ca imagine",
        "description": "Exportă datele scenei ca fișier din care poți importa mai târziu."
      },
      "saveToDisk": {
        "title": "Salvare pe disc",
        "button": "Salvare pe disc",
        "description": "Exportă datele scenei pe un fișier din care poți importa mai târziu."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportare în Excalidraw+",
        "description": "Salvează scena în spațiul de lucru Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Încărcare din fișier",
        "button": "Încărcare din fișier",
        "description": "Încărcarea dintr-un fișier va <bold>înlocui conținutul existent</bold>.<br></br>Poți face mai întâi o copie de rezervă a desenului folosind una dintre opțiunile de mai jos."
      },
      "shareableLink": {
        "title": "Încărcare din lnk",
        "button": "Înlocuiește conținutul meu",
        "description": "Încărcarea unui desen extern va <bold>înlocui conținutul existent</bold>.<br></br>Poți face mai întâi o copie de rezervă a desenului folosind una dintre opțiunile de mai jos."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid la Excalidraw",
    "button": "Introducere",
    "description": "În prezent, numai <flowchartLink>Organigramele</flowchartLink>, <sequenceLink>Diagramele de secvență</sequenceLink> și <classLink>Diagramele de clasă</classLink> sunt acceptate. Celelalte tipuri vor fi redate ca imagine în Excalidraw.",
    "syntax": "Sintaxă Mermaid",
    "preview": "Previzualizare",
    "label": "Mermaid",
    "inputPlaceholder": "Scrie definiţia diagramei Mermaid aici..."
  },
  "ttd": {
    "error": "Eroare!"
  },
  "chat": {
    "inputPlaceholder": "Începe să îți introduci ideea de diagramă aici... ({{shortcut}} pentru linia nouă)",
    "inputPlaceholderWithMessages": "Continuă rafinarea diagramei...",
    "generating": "Se generează...",
    "rateLimitRemaining": "Cereri rămase astăzi: {{count}}",
    "role": {
      "user": "Tu",
      "assistant": "Asistent IA",
      "system": "Sistem"
    },
    "aiBeta": "Beta IA",
    "label": "Conversație",
    "menu": "Meniu",
    "newChat": "Conversație nouă",
    "deleteChat": "Ștergere conversație",
    "deleteMessage": "Ștergere mesaj",
    "viewAsMermaid": "Vizualizare ca Mermaid",
    "placeholder": {
      "title": "Hai să-ți proiectăm diagrama",
      "description": "Descrie diagrama pe care vrei să o creezi și o vom genera pentru tine.",
      "hint": "În acest moment cunoaștem organigrame, diagrame de secvență și diagrame de clasă."
    },
    "preview": "Previzualizare",
    "insert": "Introducere",
    "retry": "Reîncercare",
    "errors": {
      "promptTooShort": "Solicitarea este prea scurtă (min. {{min}} caractere)",
      "promptTooLong": "Solicitarea este prea lungă (max. {{max}} caractere)",
      "generationFailed": "Generare nereușită",
      "invalidDiagram": "A generat o diagramă nevalidă :(. Poți edita manual, reîncerca cu funcția de fixare automată sau încerca o altă solicitare.",
      "fixInMermaid": "Editare Mermaid manual →",
      "aiRepair": "Regenerare (fixare automată) →",
      "requestAborted": "Cerere anulată",
      "requestFailed": "Cerere nereușită",
      "mermaidParseError": "Eroare de sintaxă Mermaid"
    },
    "rateLimit": {
      "messageLimit": "Ai atins limita IA la planul gratuit. Încearcă Excalidraw+ pentru mai multe sau revino mâine.",
      "generalRateLimit": "Stai puțin, te grăbești! Așteaptă un moment înainte de a reîncerca.",
      "messageLimitInputPlaceholder": "Ai atins limita de mesaje"
    },
    "upsellBtnLabel": "Actualizare la Plus"
  },
  "quickSearch": {
    "placeholder": "Căutare rapidă"
  },
  "fontList": {
    "badge": {
      "old": "vechi"
    },
    "sceneFonts": "În această scenă",
    "availableFonts": "Fonturi disponibile",
    "empty": "Niciun font găsit"
  },
  "userList": {
    "empty": "Niciun utilizator găsit",
    "hint": {
      "text": "Dă clic pe un utilizator pentru a-l urmări",
      "followStatus": "În prezent urmărești acest utilizator",
      "inCall": "Utilizatorul este angajat într-un apel vocal",
      "micMuted": "Microfonul utilizatorul este pus pe mut",
      "isSpeaking": "Utilizatorul vorbește"
    }
  },
  "commandPalette": {
    "title": "Paletă de comenzi",
    "shortcuts": {
      "select": "Selectare",
      "confirm": "Confirmare",
      "close": "Închidere"
    },
    "recents": "Utilizate recent",
    "search": {
      "placeholder": "Caută meniuri, comenzi și descoperă nestemate ascunse",
      "noMatch": "Nicio comandă potrivită..."
    },
    "itemNotAvailable": "Comanda nu este disponibilă...",
    "shortcutHint": "Pentru paleta de comenzi, folosește {{shortcut}}"
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Opțiune",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "Shift",
    "spacebar": "Space",
    "delete": "Delete",
    "mmb": "Rotiță maus"
  }
}
